import React, { useEffect, useState } from "react";

const Counter = ({ end, suffix = "" }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const duration = 1500; // animation time
        const incrementTime = 20;
        const increment = Math.ceil(end / (duration / incrementTime));

        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                start = end;
                clearInterval(timer);
            }
            setCount(start);
        }, incrementTime);

        return () => clearInterval(timer);
    }, [end]);

    return (
        <span style={{
            fontSize: "38.6px",
            fontWeight: "700",
            background: "linear-gradient(180deg, #C20204 0%, #6B6B6B 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
        }}>
            {count}
            {suffix}
        </span>
    );
};

const WhyChooseArya = () => {
    return (
        <section
            className="py-5 position-relative overflow-hidden"
            style={{
                background: "#FFFCF5",
                borderRadius: "12px",
            }}
        >

            {/* Left Decorative Image */}
            <img
                src="/images/glasLeft.png"
                alt="left design"
                className="side-img-left d-none d-md-block"
            />

            {/* Right Decorative Image */}
            <img
                src="/images/glasright.png"
                alt="right design"
                className="side-img-right d-none d-md-block"
            />
            <div className="container text-center position-relative" style={{ zIndex: 2 }}>
                {/* Heading */}
                <h2 className="sub_heading" style={{ fontWeight: "700" }}>
                    Why Choose <span style={{
                        background: "linear-gradient(90deg, #4E0001 , #B40103 )",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                    }}>Arya College ?</span>
                </h2>

                <p style={{
                    background: "linear-gradient(90deg, #B40103, #4E0001)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                }} className="mb-0">
                    Trusted. Accredited. Accomplished.
                </p>
                <div className="row">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                        <p className="mb-0" style={{ fontSize: "14px", color: '#515151' }}>
                            Arya College Jaipur opens B.Tech admissions for 2026. Reserve your seat at a trusted Jaipur institute offering hands-on learning, career-ready courses, and well-equipped campus facilities.
                        </p>
                    </div>
                    <div className="col-lg-3"></div>
                </div>


                {/* Accreditation Cards */}
                <div className="row">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div className="row justify-content-center my-4 gx-5 gy-3">
                            <div className="col-xl-1"></div>
                            {/* NAAC Card */}
                            <div className="col-md-4 col-xl-3 col-10">
                                <div
                                    style={{
                                        border: "1px solid #962322",
                                        borderRadius: "10px",
                                        padding: "18px 0px",
                                        background: "#FFFCF5",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "9px",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src="/images/naac.svg"
                                        alt="NAAC"

                                        style={{
                                            width: "63px",
                                            height: "40px",
                                            objectFit: "contain",
                                            borderRight: "1px solid #DDB95A",
                                        }}
                                    />
                                    <p
                                        className="mb-0 d-flex flex-column"
                                        style={{ lineHeight: "1", margin: 0 }}
                                    >
                                        <div className="text-start" style={{ color: "#000000", fontSize: "18px", margin: 0 }}>
                                            NAAC
                                        </div>

                                        <span style={{ fontSize: "15px", margin: 0 }}>
                                            A+ Accredited
                                        </span>
                                    </p>
                                </div>
                            </div>

                            {/* RTU Ranked Card */}

                            <div className="col-md-4 col-xl-3 col-10">
                                <div
                                    style={{
                                        border: "1px solid #962322",
                                        borderRadius: "10px",
                                        padding: "18px 0px",
                                        background: "#FFFCF5",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "9px",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src="/images/a.svg"
                                        alt="RTU Ranked A"
                                        className="pe-1"
                                        style={{
                                            width: "34px",
                                            height: "35px",
                                            objectFit: "contain",
                                            borderRight: "1px solid #DDB95A",
                                        }}
                                    />
                                    <p
                                        className="mb-0 d-flex flex-column"
                                        style={{ lineHeight: "1", margin: 0 }}
                                    >
                                        <div className="text-start" style={{ color: "#000000", fontSize: "18px", margin: 0 }}>
                                            Ranked
                                        </div>

                                        <span style={{ fontSize: "15px", margin: 0 }}>
                                            by RTU
                                        </span>
                                    </p>
                                </div>
                            </div>






                            {/* <div className="col-md-3 col-10">
                                <div
                                    style={{
                                        border: "1px solid #962322",
                                        borderRadius: "10px",
                                        padding: "15px",
                                        background: "#FFFCF5",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src="/images/a.svg"
                                        alt="RTU Ranked A"
                                        className="pe-3"
                                        style={{
                                            width: "50px",
                                            height: "45px",
                                            objectFit: "contain",
                                            borderRight: "1px solid #DDB95A",
                                        }}
                                    />
                                    <p className=" mb-0" style={{ fontSize: "15px" }}>
                                        <span className="fs-4" style={{ color: "#000000" }}>Ranked</span>
                                        <br /><span className="ms-0">by RTU</span>
                                    </p>
                                </div>
                            </div> */}

                            {/* NBA Card */}
                            <div className="col-md-4 col-xl-3 col-10">
                                <div
                                    style={{
                                        border: "1px solid #962322",
                                        borderRadius: "10px",
                                        padding: "18px 0px",
                                        background: "#FFFCF5",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "9px",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src="/images/nba_logo.svg"
                                        alt="NBA"

                                        style={{
                                            width: "50px",
                                            height: "40px",
                                            objectFit: "contain",
                                            borderRight: "1px solid #DDB95A",
                                        }}
                                    />
                                    <p
                                        className="mb-0 d-flex flex-column"
                                        style={{ lineHeight: "1", margin: 0 }}
                                    >
                                        <div className="text-start" style={{ color: "#000000", fontSize: "18px", margin: 0 }}>
                                            Accredited
                                        </div>

                                        <span style={{ fontSize: "15px", margin: 0 }}>
                                            (CSE Branch)
                                        </span>
                                    </p>
                                </div>
                            </div>

                            <div className="col-xl-1"></div>

                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                </div>

                <h3 className="mb-0" style={{
                    background: "linear-gradient(90deg, #B40103, #590102)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent", fontSize: "18px", fontWeight: "500"
                }}>Outcome-Focused</h3>
                {/* Stats Counter */}
                {/* <div className="row mt-4 g-4">
                    <div className="col-md-2 col-6">
                        <Counter end={22} suffix="+" />
                        <p>Years of success</p>
                    </div>

                    <div className="col-md-2 col-6">
                        <Counter end={30} suffix="+" />
                        <p>Awards Won</p>
                    </div>

                    <div className="col-md-3 col-6">
                        <Counter end={200} suffix="+" />
                        <p>Paid Internships</p>
                    </div>

                    <div className="col-md-2 col-6">
                        <Counter end={850} suffix="+" />
                        <p>Campus Drives</p>
                    </div>

                    <div className="col-md-3 col-12">
                        <Counter end={15500} suffix="+" />
                        <p>Students Placed</p>
                    </div>
                </div> */}

                {/* Stats Counter */}
                <div className="row mt-4 g-4 justify-content-center">
                    <div className="col-md-1"> </div>
                    <div className="col-md-2 col-6 text-center">
                        <Counter end={26} suffix="+" />
                        <p>Years of success</p>
                    </div>

                    <div className="col-md-2 col-6 text-center">
                        <Counter end={30} suffix="+" />
                        <p>Awards Won</p>
                    </div>

                    <div className="col-md-2 col-6 text-center">
                        <Counter end={200} suffix="+" />
                        <p>Paid Internships</p>
                    </div>

                    <div className="col-md-2 col-6 text-center">
                        <Counter end={850} suffix="+" />
                        <p>Campus Drives</p>
                    </div>

                    <div className="col-md-2 col-6 text-center">
                        <Counter end={15500} suffix="+" />
                        <p>Students Placed</p>
                    </div>
                    <div className="col-md-1"> </div>
                </div>
            </div>
            <style>
                {`
    .side-img-left {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
    //   max-height: 500px;
      object-fit: contain;
      z-index: 0;
    }

    .side-img-right {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
    //   max-height: 500px;
      object-fit: contain;
      z-index: 0;
    //   transform: scaleX(-1);
    }

    @media (max-width: 991px) {
      .side-img-left,
      .side-img-right {
        display: none;
      }
    }
  `}
            </style>
        </section >

    );
};

export default WhyChooseArya;